import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";

const Header = () => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const { count } = useCart();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-black bg-[#FFF5F7]/85 backdrop-blur-xl"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10 flex items-center justify-between h-16 gap-3">
        <Link to="/" data-testid="brand-link" className="flex items-baseline gap-2 shrink-0">
          <span className="font-serif-display text-2xl sm:text-3xl font-black tracking-tight">
            Briology
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2 md:gap-5 overflow-x-auto no-scrollbar">
          <Link
            to="/"
            data-testid="nav-builder"
            className="overline text-[10px] sm:text-[11px] hover:text-[#FF1493] transition-colors whitespace-nowrap"
          >
            Builder
          </Link>
          <Link
            to="/about"
            data-testid="nav-about"
            className="overline text-[10px] sm:text-[11px] hover:text-[#FF1493] transition-colors whitespace-nowrap"
          >
            About
          </Link>
          {isAdmin ? null : (
            <Link
              to="/account"
              data-testid="nav-account"
              className="overline text-[10px] sm:text-[11px] hover:text-[#FF1493] transition-colors whitespace-nowrap"
            >
              Account
            </Link>
          )}
          <Link
            to="/cart"
            data-testid="nav-cart"
            aria-label="Cart"
            className="relative flex items-center gap-1.5 border border-black px-2.5 py-1 hover:bg-[#FF1493] hover:text-white transition-colors ml-1 sm:ml-2"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <path d="M3 6h18"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <span
              data-testid="nav-cart-count"
              className="overline text-[10px] sm:text-[11px] leading-none"
            >
              {count}
            </span>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
